import { render, staticRenderFns } from "./ed-edit-staff.component.vue?vue&type=template&id=491a429e&scoped=true&"
import script from "./ed-edit-staff.component.ts?vue&type=script&lang=ts&"
export * from "./ed-edit-staff.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-edit-staff.component.scss?vue&type=style&index=0&id=491a429e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491a429e",
  null
  
)

export default component.exports